import { useState, useContext } from 'react';
import callContext from '@/pages/crm/callCenter/callManage/callManageContext'
import styles from '../index.module.less';
import UserInfoModule from './UserInfoModule';
import FollowUpDiary from './FollowUpDiary';
import CallRecord from './CallRecord';
import { SListTabs } from 'shj-components';
function Bottom(props: any) {
  let { updateCallManageState } = useContext(callContext)
  
  const [menusList, setMenusList] = useState([
    {
      key: 'userInfo',
      label: '客户信息',
      children: (
        <UserInfoModule/>
      )
    },
    {
      key: 'followUpDiary',
      label: '跟进日志',
      children: (
        <FollowUpDiary />
      )
    },
    {
      key: 'callRecord',
      label: '通话记录',
      children: (
        <CallRecord/>
      )
    },
  ]);

  const tabClick = (v: any) => {
    updateCallManageState({'detailsTabId':v})
  };

  return (
    <div className={styles.bottom}>
      <SListTabs items={menusList} hideExtra onChange={tabClick} />
    </div>
  );
}

export default Bottom;
